const mutations = {
  onNotifications (state, payload) {
    payload.event.context.notifications = payload.response.data.data.data
    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
    }
    payload.event.context.loadTable = false
    payload.event.context.selected = []
  },
  onMarkAsView (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
    payload.event.context.close()
  },
  redirectInspection (state, payload) {
    if(payload.response.data.data.inspection_id !== null) return payload.event.context.redirectInspection(payload.response.data.data.inspection_id)
    
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.get()
    payload.event.context.close()
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}

export default mutations